import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import {
  closeSession,
  resetBook,
  setHotelBookType,
  fetchApplicableTravelWalletItems,
} from "./actions/actions";
import { fetchTravelWalletCreditHistory, fetchTravelWalletDetails } from "../travel-wallet/actions/actions";

import { IStoreState } from "../../reducers/types";
import { HotelBook } from "./component";
import {
  getReviewHotelDetailsCheckoutProperties,
  getHotelBookChosenProduct,
  getHotelBookSelectedAvailability,
  hotelBookTypeSelector,
  getPriceQuote,
  getFromDateInBook,
  getUntilDateInBook,
  getHotelTripTotalInPrices,
} from "./reducer";
import {
  hotelCfarQuoteFromChosenRoomProductSelector,
  additionalInfoFromChosenRoomProductSelector,
  getHotelCfarOfferChoicePropertiesSelector,
} from "../shop/reducer/selectors";
import { getRewardsAccountsReferenceIds } from "../rewards/reducer";
import { getLocation } from "../search/reducer";
import { setIsTravelApp } from "../availability/actions/actions";

const mapStateToProps = (state: IStoreState) => {
  return {
    chosenProduct: getHotelBookChosenProduct(state),
    selectedLodging: getHotelBookSelectedAvailability(state),
    reviewHotelDetailsProperties:
      getReviewHotelDetailsCheckoutProperties(state),
    hotelCfarQuote: hotelCfarQuoteFromChosenRoomProductSelector(state),
    additionalInfo: additionalInfoFromChosenRoomProductSelector(state),
    getHotelCfarOfferChoiceProperties:
      getHotelCfarOfferChoicePropertiesSelector(state),
    hotelBookType: hotelBookTypeSelector(state),
    priceQuote: getPriceQuote(state),
    checkInDate: getFromDateInBook(state),
    checkOutDate: getUntilDateInBook(state),
    tripTotal: getHotelTripTotalInPrices(state),
    accountReferenceIds: getRewardsAccountsReferenceIds(state),
    searchLocation: getLocation(state),
    walletDetailsCallState: state.hotelTravelWallet.fetchTravelWalletDetailsCallState,
  };
};

const mapDispatchToProps = {
  closeSession,
  resetBook,
  setHotelBookType,
  fetchApplicableTravelWalletItems,
  fetchTravelWalletCreditHistory,
  fetchTravelWalletDetails,
  setIsTravelApp,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type HotelBookConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedHotelBook = withRouter(connector(HotelBook));
